import { HealthIssue, LinkMapping } from '@dbt-labs/metadata-shared';

import { HealthIssueType } from '@/__generated__/graphql';
import { useDbtCloudAccount } from '@/context/DbtCloudProvider';
import { UrlEnvironmentType } from '@/typings/url';
import { useLinkToExplorer } from './links';

export const useGetLinkMapping = () => {
  const { accountId } = useDbtCloudAccount();
  const getDetailsPageLink = useLinkToExplorer('resourceDetails');
  return ({
    healthIssues,
    projectId,
    environmentType,
    uniqueId,
  }: {
    healthIssues: HealthIssue[];
    projectId: number;
    environmentType: UrlEnvironmentType;
    uniqueId: string;
  }) =>
    healthIssues.reduce((mappings, value) => {
      if (value === HealthIssueType.CautionUpstreamSources) {
        mappings[HealthIssueType.CautionUpstreamSources] = {
          to: getDetailsPageLink({
            accountId: accountId ?? 0,
            projectId,
            environmentType,
            dbtUniqueId: uniqueId,
          }),
          state: { isSourcesOpen: true },
        };
      }
      return mappings;
    }, {} as LinkMapping);
};
